import React from 'react';
import { LocaleContext } from '../context';

export function useLocale() {
  return React.useContext(LocaleContext);
}
